export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
        "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["in ", _interpolate(_named("number")), " objects"])}
      },
      "de": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])},
        "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurücksetzen"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["in ", _interpolate(_named("number")), " Objekten"])}
      }
    }
  })
}
